module.exports = __webpack_public_path__ + "static/media/step_003.019fef76.jpg";